import { Avatar, AvatarFallback, AvatarImage } from "@spz/ui/components/avatar";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@spz/ui/components/tooltip";
import { cn } from "@spz/ui/lib/utils";
import type { TableUserCellProps } from "../types";
import { EmptyCell } from "./EmptyCell";

export const UserCell: React.FC<TableUserCellProps> = ({
  value,
  className,
}) => {
  if (!value)
    return <EmptyCell className={cn("flex justify-center", className)} />;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn("flex justify-center items-center", className)}>
            <Avatar size="M">
              {value.avatarUrl ? (
                <AvatarImage src={value.avatarUrl} alt={value.fullName} />
              ) : (
                <AvatarFallback
                  firstName={value.firstName}
                  lastName={value.lastName}
                  size="M"
                />
              )}
            </Avatar>
          </span>
        </TooltipTrigger>
        <TooltipContent side="top">{value.fullName}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
